import React from 'react'
import style from "./cart.module.css";
import Header from '../components/header/Header';
import Navbar from '../components/navbar/Navbar';
import Footer from '../components/footer/Footer';

const Cart = () => {
  return (
    <>
    <Header/>
    <Navbar/>
    <h1>Cart</h1>
    <Footer/>
    </>
  )
}

export default Cart
